import * as React from 'react';

import { declOfNum, getTranslation, translations } from '@base/utils';

import { PaymentTitle } from './PaymentTitle';

interface IPaymentSuccessProps {
	price: number;
	serviceName: string;
	appId: string;
	onBackToGame?(): void;
}

export const PaymentSuccess = ({ price, serviceName }: IPaymentSuccessProps) => {
	const paymentTranslation = getTranslation('pages.PaymentResult');
	const globalTranslation = translations.common;
	const mailik = declOfNum(
		[
			globalTranslation('plural.mailik.0'),
			globalTranslation('plural.mailik.1'),
			globalTranslation('plural.mailik.2'),
		], price);
	const isShowInfoBlock = Boolean(serviceName) && Boolean(price);

	return (
		<div>
			<PaymentTitle>{paymentTranslation('success')}</PaymentTitle>
			{ isShowInfoBlock &&
				<div style={{ marginBottom: '10px' }}>
					<span>{paymentTranslation('successInfo')}</span>
					<b> {serviceName}</b>
					<span> {paymentTranslation('for')}</span>
					<b> {price}</b>&nbsp;<span>{mailik}</span>
				</div>
			}
		</div>
	);
};
